export default "__VITE_ASSET__BR8C88UU__"